import React from 'react';

function Navbar() {
  return (
    <nav>
      <h1>Project name</h1>
    </nav>
  );
}

export default Navbar;

